import React from 'react';
import cardStyles from 'assets/css/Card.module.css';
import buttonStyles from 'assets/css/Button.module.css';
import CardLink from 'Components/Card/CardLink';
import { IconAngleRight } from '@ace/react-icons';

function AceAnswersStudySupportCard(props) {
    //local var(s)
    const { data } = props;

    //render
    return (
        <div className={cardStyles.cardBodyDefault}>
            {
                data.Links.map(link => {
                    return (
                        <CardLink
                            linkText={link.CardLinkText}
                            linkUrl={link.CardLinkUri}
                            linkIcon={<IconAngleRight />}
                            target="_blank"
                            style={{textAlign: "left", marginBottom: "1rem"}}
                            className={`${buttonStyles.floating}`} />
                    )
                })
            }
        </div>
    )
}

export default AceAnswersStudySupportCard;
